var map = {
	"./godwealth2_en.png": "faPu",
	"./godwealth2_esp.png": "ClT9",
	"./godwealth2_th.png": "aisi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kZWk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/godwealth2_.*\.png$
// module id = kZWk
// module chunks = 1